import type { CSSProperties } from 'react';

import { e } from './escenaCss';

type GaviTintaProps = {
  /** Ancho en px (alto proporcional, 64 × 60 de lienzo). */
  ancho?: number;
  className?: string;
  style?: CSSProperties;
};

/**
 * Gavi entintada para la escena de la botella («Gavi a tinta aquí»): la
 * misma geometría que `travesia/Gavi.tsx`, con trazo de tinta, sin
 * mofletes ni brillo en el ojo, para que case con el tono de grabado. La
 * Gavi normal de la app no cambia. Sin animación propia: la mueve la
 * escena.
 */
export function GaviTinta({ ancho = 44, className, style }: GaviTintaProps) {
  return (
    <svg
      viewBox="0 0 64 60"
      width={ancho}
      height={(ancho * 60) / 64}
      className={className}
      style={style}
      data-testid="gavi-tinta"
      aria-hidden
    >
      <g stroke={e.gaviTrazo} strokeWidth="1.3" strokeLinejoin="round">
        <path d="M8 40 L1 44 L10 45 Z" fill={e.gaviAla} />
        <ellipse cx="28" cy="40" rx="19" ry="13" fill={e.gavi} />
        <circle cx="42" cy="24" r="11" fill={e.gavi} />
        <path d="M51 25 L61 27.5 L51 30 Z" fill={e.laton} />
        <path d="M12 38 Q22 25 40 33 Q31 38 21 47 Z" fill={e.gaviAla} />
      </g>
      <circle cx="45.5" cy="21.5" r="1.8" fill={e.gaviTrazo} />
      <path
        d="M26 53 L24 59 M33 53 L35 59"
        stroke={e.laton}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
